export default __webpack_public_path__ + "static/media/tarun.4f1395b3.jpg";